<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
				<div class="col-12 col-lg-8 px-0">
					<div class="col-12 px-2 py-3 p-md-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
						<div class="col-2 col-md-1 my-auto">
							<div class="font-size-12 font-size-sm-10">
								<router-link class="text-deco" to="/receipt">
									<i class="fas fa-arrow-left color-light-black"></i>
								</router-link>
							</div>
						</div>
						<div class="col-10 col-md-11 pl-0 d-md-flex justify-content-between" v-if="detailReceipt.sdo_code">
							<div class="font-size-14 font-size-sm-12 font-weight-bold color-blue">{{ detailReceipt.sdo_code }}</div>
							<div class="font-weight-bold">{{ detailReceipt.sdo_status_on_delivery_datetime | tanggaljam }}</div>
						</div>
						<div class="col-10 col-md-11 pl-0" v-else>
							<vcl :width='300' :height='10'>
								<rect x="0" y="0" rx="2" ry="2" width="85" height="10" />
								<rect x="245" y="0" rx="2" ry="2" width="55" height="10" />
							</vcl>
						</div>
					</div>
					<div>
						<div class="col-12 px-2 py-3 p-md-3 mt-3 rounded-cus cus-box-shadow bg-white" v-if="Object.values(detailReceipt).length == 0">
							<vcl :width='300' :height='142'>
								<rect x="5" y="3" rx="2" ry="2" width="75" height="10" />
								<rect x="5" y="20" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="20" rx="2" ry="2" width="75" height="6" />
								<rect x="5" y="30" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="30" rx="2" ry="2" width="50" height="6" />
								<rect x="5" y="40" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="40" rx="2" ry="2" width="50" height="6" />
								<rect x="5" y="54" rx="2" ry="2" width="120" height="50" />
								<rect x="130" y="54" rx="2" ry="2" width="120" height="50" />
								<rect x="5" y="113" rx="2" ry="2" width="30" height="6" />
								<rect x="5" y="123" rx="2" ry="2" width="75" height="6" />
								<rect x="5" y="133" rx="2" ry="2" width="75" height="6" />
								<rect x="85" y="128" rx="2" ry="2" width="40" height="6" />
								<rect x="130" y="113" rx="2" ry="2" width="30" height="6" />
								<rect x="130" y="123" rx="2" ry="2" width="75" height="6" />
								<rect x="130" y="133" rx="2" ry="2" width="75" height="6" />
								<rect x="210" y="128" rx="2" ry="2" width="40" height="6" />
							</vcl>
						</div>
						<div class="col-12 px-2 py-3 p-md-3 mt-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white" v-else>
							<div class="col-12 pb-3 font-size-sm-12 font-size-14 text-uppercase font-weight-bold">{{ detailReceipt.warehouse_name }}</div>
							<div class="col-12 pb-4 font-size-sm-10 font-size-12">
								<div class="row">
									<div class="col-12 col-md-2 font-weight-bold">Alamat</div>
									<div class="col-12 col-md-10">{{ detailReceipt.warehouse_address }}</div>
									<div class="pt-2 col-12 col-md-2 font-weight-bold">Phone</div>
									<div class="pt-md-2 col-12 col-md-10">{{ detailReceipt.warehouse_mobilephone }}</div>
								</div>
							</div>
							<div class="col-12 pb-4 font-size-sm-10 font-size-12">
								<div class="row">
									<div class="col-12 col-md-8 col-lg-6 pr-lg-2">
										<div class="col-12 py-2 rounded-cus border-dashed border-width-1 h-100">
											<div class="row">
												<div class="col-3">Nomor</div>
												<div class="col-9">
													<span>:</span>
													<span class="pl-3">{{ detailReceipt.sdo_code }}</span>
												</div>
												<div class="pt-2 col-3">Tanggal</div>
												<div class="pt-2 col-9">
													<span>:</span>
													<span class="pl-3">{{ detailReceipt.sdo_status_on_delivery_datetime | tanggaljam }}</span>
												</div>
												<div class="pt-2 col-3" v-if="false">Bayar</div>
												<div class="pt-2 col-9" v-if="false">
													<span>:</span>
													<span class="pl-3">BRI Rp 21.750.000</span>
												</div>
												<div class="pt-2 col-3">MC ID</div>
												<div class="pt-2 col-9">
													<span>:</span>
													<span class="pl-3">{{ userData.stockist_code }}</span>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-8 col-lg-6 pt-3 pt-lg-0 pl-lg-2">
										<div class="col-12 py-2 rounded-cus border-dashed border-width-1 h-100">
											<div class="row">
												<div class="col-3">Penerima</div>
												<div class="col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_name }}</div>
												</div>
												<div class="pt-2 col-3">Telepon</div>
												<div class="pt-2 col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_mobilephone }}</div>
												</div>
												<div class="pt-2 col-3">Alamat</div>
												<div class="pt-2 col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_address }}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 pb-2 pb-lg-4 font-size-12">
								<div class="pt-2 table-responsive">
									<table class="table table-bordered mb-0 font-size-sm-9 font-size-10">
										<thead class="bg-pos">
											<tr>
												<td>No</td>
												<td>Jenis Barang</td>
												<td>Jumlah</td>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(product, i) in detailReceipt.detail" :key="product.sdo_detail_id">
												<td>{{ i+1 }}</td>
												<td>{{ product.sdo_detail_product_name }}</td>
												<td>{{ product.sdo_detail_quantity_received }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="col-12 pb-2 font-size-12">
								<div class="row">
									<div class="col-12 col-md-8 col-lg-6 pt-3 pt-lg-0 pr-md-2 mb-4" v-for="detail in detailReceipt.detail" :key="detail.sdo_detail_id">
										<div class="font-weight-bold font-size-sm-10 font-size-12">{{ detail.sdo_detail_product_name }}</div>
										<div class="row">
											<div class="col-12 col-md-8">
												<div class="pt-2 d-flex justify-content-between">
													<div class="font-size-9 my-auto">Jumlah yang sudah {{detail.sdo_detail_product_is_serial > 0 ? 'diproses' : 'dikonfirmasi'}}</div>
													<div class="font-size-sm-12 font-size-14 color-green">{{ detail.sdo_receive_quantity_scanned }}</div>
												</div>
												<div class="pt-1 d-flex justify-content-between">
													<div class="font-size-9 my-auto">Jumlah yang belum {{detail.sdo_detail_product_is_serial > 0 ? 'diproses' : 'dikonfirmasi'}}</div>
													<div class="font-size-sm-12 font-size-14 color-red">{{ detail.sdo_receive_quantity_unscanned }}</div>
												</div>
											</div>
											<div class="col-12 col-md-4 mt-auto pt-2 pt-md-0" v-if="detail.sdo_detail_product_is_serial > 0">
												<button v-if="detail.sdo_receive_quantity_unscanned > 0" class="col-12 py-2 rounded-pill btn btn-blue box-purple d-flex justify-content-center" @click="listSerialChange(detail.sdo_detail_id)">
													<span class="font-size-10 font-size-sm-8"><i class="fas fa-qrcode"></i></span>
													<div class="pl-2 pl-md-3 font-size-11 font-size-sm-9 text-uppercase font-weight-bold">Scan</div>
												</button>
											</div>
											<div class="col-12 col-md-4 mt-auto pt-2 pt-md-0" v-else>
												<button v-if="detail.sdo_receive_quantity_unscanned > 0" class="col-12 py-2 rounded-pill btn btn-blue box-purple d-flex justify-content-center" @click="inputNonSerial(detail)">
													<span class="font-size-10 font-size-sm-8">{{detail.sdo_receive_quantity_unscanned}}</span>
													<div class="pl-2 pl-md-3 font-size-11 font-size-sm-9 text-uppercase font-weight-bold">Input</div>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-4 pl-0 pr-0 pl-lg-3 mt-3 mt-lg-0">
					<div class="col-12 px-2 py-3 p-md-3 justify-content-between rounded-cus cus-box-shadow bg-white list-serial">
						<div v-if="!listSerial">
							<div>Belum Ada List Serial Dipilih</div>
						</div>
						<transition name="slide-fade">
							<div class="col-12 font-size-sm-10 mb-1 font-size-12" v-if="listSerial">
								<div class="mb-3">Silahkan masukan atau scan {{ productScan.sdo_receive_quantity_unscanned }} serial {{ productScan.sdo_detail_product_name }}</div>
								<div class="mb-3 d-flex justify-content-center">
									<div class="col-11 p-3 container-scanner detail-receipt">
										<QrcodeStream @decode="onDecode" :class="camera == 'front' ? 'front-camera' : ''" @init="onInit" :camera="camera">
											<div class="text-right">
												<button @click="switchCamera">
													<img src="/assets/icon/camera-switch.svg" alt="switch camera">
												</button>
											</div>
										</QrcodeStream>
									</div>
								</div>
								<!-- <div class="px-1 py-2 container-scanner mx-auto">
									<QrcodeStream @decode="onDecode"></QrcodeStream>
								</div> -->
								<div class="px-3 py-1 mb-2 cus-box-shadow rounded-pill">
									<div class="d-flex justify-content-between">
										<input v-model="serialInput" @keyup.enter="syncNow(serialInput)" type="text" class="form-control form-control-sm no-border box-blue rounded-cus font-size-sm-10 font-size-12" id="inputSerial">
										<div class="pl-3 color-green my-auto" @click="syncNow(serialInput)"><i class="fas fa-search"></i></div>
									</div>
								</div>
							</div>
						</transition>
						<transition name="slide-fade">
							<div class="col-12 py-2 mb-4 list-serial-box" v-if="listSerial">
								<button class="col-12 py-2 mb-2 rounded-pill btn btn-blue box-purple d-inline-flex justify-content-center" v-if="false">
									<span class="font-size-10 font-size-sm-8"><i class="fas fa-sync-alt"></i></span>
									<div class="pl-3 font-size-11 font-size-sm-9 text-uppercase font-weight-bold">Sinkronisasi Data</div>
								</button>
								<div class="px-3 py-1 mb-2 cus-box-shadow rounded-pill" v-for="(serial, index) in parseInt(productScan.sdo_receive_quantity_unscanned)" :key="index">
									<div class="d-flex justify-content-between">
										<input type="text" v-model="serialScan[index]" readonly class="form-control form-control-sm no-border box-blue rounded-cus font-size-sm-10 font-size-12">
										<div class="pl-3 color-green my-auto" v-show="isValidSerial(serialScan[index])"><i class="fas fa-check"></i></div>
										<div class="pl-3 color-grey my-auto" v-show="!isValidSerial(serialScan[index])"><i class="far fa-circle"></i></div>
									</div>
								</div>
							</div>
						</transition>
						<transition name="slide-fade">
							<div class="col-12 py-3 text-center mb-4 list-serial-box" v-if="!listSerial">
								<img class="img-fluid" src="/assets/receipt/empty-data.png">
								<div class="pt-2 font-size-10">Belum ada data yang dapat ditampilkan</div>
							</div>
						</transition>
						<div class="col-12 pb-2 btn-sinkron">
							<button :disabled="serialScan.length == 0" class="col-12 py-2 rounded-pill btn btn-blue box-purple d-inline-flex justify-content-center" v-if="listSerial" @click="confirmProses('serial')">
								<!-- <span class="font-size-10 font-size-sm-8"><i class="fas fa-sync-alt"></i></span> -->
								<div class="pl-3 font-size-11 font-size-sm-9 text-uppercase font-weight-bold">Proses Serial</div>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alertMessage" type="alert" @remove="removeAlert"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalConfirmation" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="$refs.modalConfirmation.modalHide()" @confirm="prosesSerial"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalReceiveInput" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-12 col-md-12 text-center">
							Masukan jumlah barang yang diterima
						</div>
						<div class="col-12 col-md-12 text-center">
							<input type="text" v-model="product_quantity" @focus="alertQty = ''" @keypress="onlyNumber" @paste.prevent class="form-control form-control-sm box-blue rounded-cus font-size-sm-10 font-size-12 text-center">
							<div class="font-size-8 pt-1 color-red text-capitalize">{{alertQty}}</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-3 d-flex justify-content-center justify-content-md-end">
						<button class="col-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="$refs.modalReceiveInput.modalHide()">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Batal</div>
						</button>
						<button class="col-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="proccessNonSerial">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Simpan</div>
						</button>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import $ from 'jquery';
import helperReceipt from "@/helpers/receipt";
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
	components: {
		AlertModal, IModal, QrcodeStream
	},
	data() {
		return {
			listSerial: false,
			serialInput:'',
			productScan: {},
			serialScan: [],
			alertMessage: '',
			confirmMessage: '',
			typeProccess: '',
			dataProduct: '',
			product_quantity: '',
			alertQty: '',
			camera: 'front',
			noRearCamera: false,
			noFrontCamera: false,
			alert: '',
		}
	},
	computed: {
		...mapState('receipt', ['detailReceipt', 'dataSerial', 'serialInvalid']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('receipt', ['getDetailReceipt', 'syncSerial', 'proccessSerial', 'getSerialStashed']),
		...mapMutations('receipt', ['refreshListSerial', 'setSerialInvalid']),
		...mapActions('transactionList', ['scanLinkSerial']),

		async listSerialChange(id) {
			this.productScan = await this.detailReceipt.detail.find((el) => el.sdo_detail_id == id)
			await this.getSerialStashed({
				sdo_id: this.productScan.sdo_detail_sdo_id,
				product_id: this.productScan.sdo_detail_product_id,
				product_is_serial: this.productScan.sdo_detail_product_is_serial,
			})
			var serial = await helperReceipt.getSerialData()
			this.serialScan = serial.serial
			/*var sdo = await serial.find(el => el.sdo_id == this.productScan.sdo_detail_sdo_id)
			if (sdo) {
				var detail = await sdo.detail.find(el => el.serial_type == this.productScan.sdo_detail_product_is_serial)
				if (detail) {
					this.serialScan = await detail.serial_valid
				} else {
					this.serialScan = []
				}
			}*/
			$('#inputSerial').focus()
			this.listSerial = await true
			var ls = $('.list-serial').offset().top;
			ls -= 90;
			$('html').scrollTop(ls);
		},
		syncNow(val, index) {
			if (!val) {
				this.alertMessage = "Serial tidak boleh kosong"
				this.$refs.modalAlert.modalShow()
			} else if (this.productScan.sdo_receive_quantity_unscanned <= this.serialScan.length) {
				this.alertMessage = "Scan serial sudah maksimal"
				this.$refs.modalAlert.modalShow()
			} else {
				if (this.isValidSerial(val)) {
					this.alertMessage = "Serial sudah digunakan"
					this.$refs.modalAlert.modalShow()
				} else {
					let params = {
						value: {
							sdo_id : this.productScan.sdo_detail_sdo_id,
							serial_type: this.productScan.sdo_detail_product_is_serial,
							serial: [val]
						}, 
						index: index
					}
					this.syncSerial(params).then(() => {
						this.serialInput = ''
						document.getElementById("inputSerial").focus();
						this.listSerialChange(this.productScan.sdo_detail_id)
					}).catch(index => {
						if (index >= 0) {
							this.alertMessage = "Serial ini tidak bisa digunakan"
							this.$refs.modalAlert.modalShow()
						}
					})
				}
			}
		},
		removeAlert(){
			this.$refs.modalAlert.modalHide()
			this.alertMessage = ''
		},
		isValidSerial(value) {
			var serial = helperReceipt.getSerialData()
			return serial.serial.includes(value)
			/*var sdo = this.dataSerial.find(el => el.sdo_id == this.productScan.sdo_detail_sdo_id)
			if (sdo) {
				var detail = sdo.detail.find(el => el.serial_type == this.productScan.sdo_detail_product_is_serial)
				if (detail) {
					return detail.serial_valid.includes(value)
				}
			}
			return false*/
		},
		inputNonSerial(data) {
			this.dataProduct = data
			this.$refs.modalReceiveInput.modalShow()
		},
		proccessNonSerial() {
			if (this.product_quantity == '' || this.product_quantity <= 0) {
				this.alertQty = 'Jumlah tidak boleh kosong'
			} else if (this.product_quantity > this.dataProduct.sdo_receive_quantity_unscanned) {
				this.alertQty = 'Tidak boleh melebihi dari jumlah yang di pesan'
			} else {
				this.alertQty = ''
				this.$refs.modalReceiveInput.modalHide()
				this.confirmProses('nonSerial')
			}
		},
		confirmProses(type) {
			this.typeProccess = type
			if (type == 'serial') {
				this.confirmMessage = "Yakin akan memproses pemilihan serial?"
			} else {
				this.confirmMessage = "Yakin akan memproses penerimaan?"
			}
			this.$refs.modalConfirmation.modalShow()
		},
		prosesSerial() {
			let params = {
				sdo_id: this.detailReceipt.sdo_id
			}
			if (this.typeProccess == 'nonSerial') {
				params.product = [{
					product_id: this.dataProduct.sdo_detail_product_id,
					quantity: this.product_quantity
				}]
			}
			this.proccessSerial(params).then(() => {
				this.listSerial = false
				this.$refs.modalConfirmation.modalHide()
				this.getDetailReceipt({
					sdo_code: this.$route.params.slug
				})
			})
		},
		onDecode(val) {
			if (val) {
				this.scanLinkSerial(val).then( ({ data }) => {
					this.serialInput = data.serial
					this.syncNow(this.serialInput)
				})
			}
		},
		switchCamera () {
			switch (this.camera) {
				case 'front':
				this.camera = 'rear'
				break
				case 'rear':
				this.camera = 'front'
				break
			}
		},
		async onInit (promise) {
			try {
				await promise
			} catch (error) {
				const triedFrontCamera = this.camera === 'front'
				const triedRearCamera = this.camera === 'rear'

				const cameraMissingError = error.name === 'OverconstrainedError'

				if (triedRearCamera && cameraMissingError) {
					this.noRearCamera = true
					this.camera  = 'front'
				}

				if (triedFrontCamera && cameraMissingError) {
					this.noFrontCamera = true
					this.camera = 'rear'
				}
			}
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Penerimaan Barang');
		this.getDetailReceipt({
			sdo_code: this.$route.params.slug
		}).catch( err =>{
			this.alertMessage = err
			this.$refs.modalAlert.modalShow()
		})
	}
};
</script>